export default __webpack_public_path__ + "static/media/home-about-hero.a4c91f9c.jpeg";